var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9959 7.65967H34.7932L24.3123 19.4394L36.6422 35.4692H26.9881L19.4265 25.7473L10.7745 35.4692H5.97423L17.1845 22.8694L5.35645 7.65967H15.2557L22.0907 16.5459L29.9959 7.65967ZM28.312 32.6455H30.9704L13.8113 10.3351H10.9587L28.312 32.6455Z",
    fill: "#161614"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.df162243cc1b38c9ec65c4028d4571e3.svg";
export { ForwardRef as ReactComponent };